import { z } from "zod";
import { AGENT_STATUSES, AGENT_ROLES, RUNTIME_TIERS } from "../constants.js";
export const createAgentSchema = z.object({
    companyId: z.string().uuid(),
    name: z.string().min(1).max(100),
    role: z.enum(AGENT_ROLES).optional(),
    title: z.string().max(100).optional(),
    icon: z.string().max(50).optional(),
    department: z.string().max(100).optional(),
    avatarUrl: z.string().max(5000).optional(),
    runtimeTier: z.enum(RUNTIME_TIERS).optional(),
    reportsTo: z.string().uuid().nullable().optional(),
    parentAgentId: z.string().uuid().nullable().optional(),
    capabilities: z.string().max(2000).optional(),
    adapterType: z.string().min(1).optional(),
    adapterConfig: z.record(z.unknown()).optional(),
    runtimeConfig: z.record(z.unknown()).optional(),
    budgetMonthlyCents: z.number().int().min(0).optional(),
    // Pre-generated workspace files from the wizard's Workspace step. When
    // present, the create flow uses these instead of generating them with the
    // platform LLM at deploy time — so the agent lands ready to work.
    workspace: z
        .object({
        identityMd: z.string().max(20000).optional(),
        soulMd: z.string().max(20000).optional(),
        userMd: z.string().max(20000).optional(),
        agentsMd: z.string().max(20000).optional(),
    })
        .optional(),
});
export const updateAgentSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    role: z.enum(AGENT_ROLES).optional(),
    title: z.string().max(100).nullable().optional(),
    icon: z.string().max(50).nullable().optional(),
    department: z.string().max(100).nullable().optional(),
    avatarUrl: z.string().max(5000).nullable().optional(),
    status: z.enum(AGENT_STATUSES).optional(),
    runtimeTier: z.enum(RUNTIME_TIERS).optional(),
    reportsTo: z.string().uuid().nullable().optional(),
    parentAgentId: z.string().uuid().nullable().optional(),
    capabilities: z.string().max(2000).nullable().optional(),
    adapterType: z.string().min(1).optional(),
    adapterConfig: z.record(z.unknown()).optional(),
    runtimeConfig: z.record(z.unknown()).optional(),
    budgetMonthlyCents: z.number().int().min(0).optional(),
});
/**
 * POST /agents/:id/subagents — update shape plus the wizard's pre-generated
 * workspace files. Kept SEPARATE from updateAgentSchema: the agent PATCH
 * route passes its validated body straight into the DB update, so a
 * workspace field there would leak a non-column key into drizzle .set().
 */
export const createSubagentSchema = updateAgentSchema.extend({
    workspace: z
        .object({
        identityMd: z.string().max(20000).optional(),
        soulMd: z.string().max(20000).optional(),
        userMd: z.string().max(20000).optional(),
        agentsMd: z.string().max(20000).optional(),
    })
        .optional(),
});
//# sourceMappingURL=agent.js.map